import './social-network-qualification-actions.ajscss';

import { ISocialNetworkFrameService } from '@agent/agent-interface/contact-view/social-network/services/social-network-frame.service';
import { IQualificationDeprecatedService } from '@agent/core/contact/qualification-deprecated.service';
import { ng1Destroy } from '@commons/util/utilities/rx';
import { IComponentController, IComponentOptions } from 'angular';

import { BookingFacade, Qualification } from '@contact/upgrade';

import templateUrl from './social-network-qualification-actions.template.html';

const MODULE_NAME = 'socialNetworkQualificationActions';

export class SocialNetworkQualificationActionsCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;
  canRenewPostTreatment = false;
  canFinishPostTreatment = false;

  private qualification: Qualification | undefined;

  constructor(
    private readonly qualificationDeprecatedService: IQualificationDeprecatedService,
    private readonly socialNetworkFrameService: ISocialNetworkFrameService,
    private readonly contactFacade: BookingFacade
  ) {}

  $onInit() {
    this.qualificationDeprecatedService.canRenewPostTreatment(this.responseId).then(can => (this.canRenewPostTreatment = can));
    this.qualificationDeprecatedService
      .canFinishPostTreatment(this.responseId)
      .pipe(ng1Destroy(this))
      .subscribe(can => (this.canFinishPostTreatment = can));

    this.contactFacade
      .getQualifById(this.responseId)
      .pipe(ng1Destroy(this))
      .subscribe(qualification => (this.qualification = qualification));
  }

  finishQualification(): void {
    this.qualificationDeprecatedService.finishQualification(this.responseId);
    this.socialNetworkFrameService.removeSocialNetwork(this.responseId);
  }

  renewPostTreatment(): void {
    this.qualificationDeprecatedService.renewPostTreatment(this.responseId).then(() => {
      if (this.qualification && this.socialNetworkFrameService.activeSocialNetwork) {
        this.socialNetworkFrameService.activeSocialNetwork.computePostTreatmentValues(Date.now(), this.qualification.renewableDuration);
        this.qualificationDeprecatedService.canRenewPostTreatment(this.responseId).then(canRenew => {
          this.canRenewPostTreatment = canRenew;
        });
      }
    });
  }
}

export class SocialNetworkQualificationActions implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  };
  controller = ['qualificationDeprecatedService', 'socialNetworkFrameService', 'contactFacade', SocialNetworkQualificationActionsCtrl];
}

export default MODULE_NAME;
